import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Helmet } from 'react-helmet-async';
import { FaPlus } from 'react-icons/fa';
import heroIosVsAndroid from '../assets/hero-ios-vs-android.jpg';
import heroIosVsAndroidMobile from '../assets/compressed/mobile/hero-ios-vs-android.jpg';
import heroIosVsAndroidTablet from '../assets/compressed/tablet/hero-ios-vs-android.jpg';
import './IosVsAndroid.css';
import ForumDiscussion from '../components/Forum/ForumDiscussion';
import NouvDiscModal from '../components/Forum/NouvDiscModal';
import useForumPagination from '../hooks/useForumPagination';

const IosVsAndroid = () => {
    const [showModal, setShowModal] = useState(false);
    const { currentUser } = useAuth();
    const {
        discussions,
        loading,
        hasMore,
        loadMore,
        refreshDiscussions
    } = useForumPagination('ios-vs-android-discussions');

    return (
        <main className="ios-vs-android-page">
            <Helmet>
                <title>iOS vs Android : Comparatif Complet - Tech Passion</title>
                <meta name="description" content="Comparaison détaillée entre iOS et Android : interface utilisateur, sécurité, personnalisation, applications, performances et écosystème. Guide complet pour choisir votre système mobile." />
                <link rel="canonical" href="https://techpassion.fr/ios-vs-android" />
                <meta name="keywords" content="iOS vs Android, comparatif mobile, iPhone vs Android, système d'exploitation mobile, Apple iOS, Google Android, différences iOS Android, choix smartphone" />
                <meta property="og:title" content="iOS vs Android : Comparatif Complet - Tech Passion" />
                <meta property="og:description" content="Découvrez notre comparaison détaillée entre iOS et Android : avantages, inconvénients et guide pour choisir votre système mobile." />
                <meta property="og:url" content="https://techpassion.fr/ios-vs-android" />
                <meta property="og:type" content="website" />
            </Helmet>

            <section className="hero">
                <div className="hero-left">
                    <div className="hero-content">
                        <h1>iOS vs Android</h1>
                        <p>Comparaison détaillée des deux systèmes d'exploitation mobiles majeurs</p>
                    </div>
                </div>
                <img 
                    className="hero-image"
                    src={heroIosVsAndroid}
                    srcSet={`${heroIosVsAndroidMobile} 480w, ${heroIosVsAndroidTablet} 768w, ${heroIosVsAndroid} 1024w`}
                    sizes="(max-width: 768px) 100vw, 50vw"
                    alt="Comparaison des écosystèmes iOS et Android avec leurs interfaces et stores d'applications"
                    loading="lazy"
                />
            </section>

            <section className="discussions-section">
                {loading ? (
                    <div className="loading">Chargement des discussions...</div>
                ) : (
                    <div className="discussions-container">
                        {discussions.map(discussion => (
                            <ForumDiscussion
                                key={discussion.id}
                                discussion={discussion}
                                collectionName="ios-vs-android-discussions"
                                onReply={refreshDiscussions}
                            />
                        ))}
                    </div>
                )}

                {hasMore && (
                    <div className="load-more-container">
                        <button 
                            className="load-more-btn"
                            onClick={loadMore}
                        >
                            Voir plus
                        </button>
                    </div>
                )}
            </section>

            {currentUser && (
                <button 
                    className="new-discussion-button" 
                    title="Nouvelle discussion"
                    onClick={() => setShowModal(true)}
                >
                    <FaPlus />
                </button>
            )}

            <NouvDiscModal 
                isOpen={showModal}
                onClose={() => setShowModal(false)}
                forumId="ios-vs-android-discussions"
                onDiscussionUpdate={refreshDiscussions}
            />
        </main>
    );
};

export default IosVsAndroid;
